/* eslint-disable max-len */
import { serviceName } from '../resources/serviceConstants';
import { TRAVEL_COST_CITIES, TRAVEL_COST, CLOUD_COST, GET_CLOUD_COST, GET_CLOUD_COST_DETAILS, UPDATE_CLOUD_COST, GET_STAFFING_COST, GET_STAFFING_COST_DETAILS, CREATE_MAN_POWER_COST, UPDATE_MAN_POWER_COST, MAN_POWER_COST_CALCULATION, SOFTWARE_COST, HARDWARE_COST } from '../resources/endPoint';

export const saveCloudCost = (data) => {
  return {
    url: CLOUD_COST,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const getCloudCost = () => {
  return {
    url: GET_CLOUD_COST,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getCloudCostDetails = () => {
  return {
    url: GET_CLOUD_COST_DETAILS,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const updateCloudCost = (data) => {
  return {
    url: UPDATE_CLOUD_COST,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const getStaffingCostOption = () => {
  return {
    url: GET_STAFFING_COST,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getStaffingCostDetails = () => {
  return {
    url: GET_STAFFING_COST_DETAILS,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const createStaffingCost = (data) => {
  return {
    url: CREATE_MAN_POWER_COST,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const updateStaffingCost = (data) => {
  return {
    url: UPDATE_MAN_POWER_COST,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const getSummaryData = () => {
  return {
    url: MAN_POWER_COST_CALCULATION,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getSoftwareCost = () => {
  return {
    url: SOFTWARE_COST,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const updateSoftwareCost = (data) => {
  return {
    url: SOFTWARE_COST,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const saveSoftwareCost = (data) => {
  return {
    url: SOFTWARE_COST,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getHardwareCost = () => {
  return {
    url: HARDWARE_COST,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
export const getTravelDestination = () => {
  return {
    url: TRAVEL_COST_CITIES,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const updateHardwareCost = (id, data) => {
  return {
    url: `${HARDWARE_COST}/${id}`,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const getTravelCostDetails = () => {
  return {
    url: TRAVEL_COST,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const saveHardwareCost = (data) => {
  return {
    url: HARDWARE_COST,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const saveTravelCost = (data) => {
  return {
    url: TRAVEL_COST,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const updateTravelCost = (data) => {
  return {
    url: TRAVEL_COST,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};
